import $ from 'jquery';
import Swal from 'sweetalert2';
import { userSubscribe } from '../../modules/userSubscribe';

export const challengesShow = () => {
  userSubscribe();

  if (sessionStorage.openShareModal == 'S') {
    document.getElementById('share-btn').click();
  }

  $('.js-check-pensar').on('click', function () {
    let $checked = $('input[name="tools[]"]:checked').length;

    if ($checked === 0) {
      Swal.fire(
        'Atenção!',
        'Você precisa selecionar um horário para capacitação e pelo menos UMA ferramenta.',
        'error'
      );
      return false;
    }
  });

  $('.js-additional-check').on('change', function (e) {
    if ($('#' + $(this).attr('data-id')).hasClass('u-display--none'))
      $('#' + $(this).attr('data-id')).removeClass('u-display--none');
    else {
      $('#' + $(this).attr('data-id')).addClass('u-display--none');
      $('#' + $(this).attr('data-id'))
        .find('input:text')
        .val('');
    }
  });

  $('.js-copy').on('click', function (e) {
    e.preventDefault();

    var range, selection, worked;
    var element = document.getElementById('challenge-link');

    if (document.body.createTextRange) {
      range = document.body.createTextRange();
      range.moveToElementText(element);
      range.select();
    } else if (window.getSelection) {
      selection = window.getSelection();
      range = document.createRange();
      range.selectNodeContents(element);
      selection.removeAllRanges();
      selection.addRange(range);
    }

    try {
      document.execCommand('copy');
      alert('Link copiado');
    } catch (err) {
      alert('unable to copy text');
    }
  });

  $('.js-modal-gallery').on('click', function () {
    Swal.fire({
      html: '<h3 class="o-ttl u-m-b-20">Galeria de imagens</h2><p><b>Não foram adicionadas imagens nessa ação.</b>',
      padding: '25px 15px',
      position: 'top',
      showConfirmButton: false,
      showClass: {
        popup: 'c-new-swal--popup',
      },
      customClass: 'c-new-swal',
    });
  });

  $('.js-modal-materials').on('click', function () {
    Swal.fire({
      html: '<h3 class="o-ttl u-m-b-20">Materiais adicionais</h2><p><b>Não foram adicionados materiais nessa ação.</b>',
      padding: '25px 15px',
      position: 'top',
      showConfirmButton: false,
      showClass: {
        popup: 'c-new-swal--popup',
      },
      customClass: 'c-new-swal',
    });
  });
};
